import useGoalInfo from '@api/hooks/goal/useGoalInfo';
import { NOTES } from '@constants/segment';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import Layout from '@layout/index';
import SEO from '@seo/index';
import subGoalSchema from '@seo/goal/subGoal';
import Head from 'next/head';
import { useRouter } from 'next/router';
import NotesHomePage from '@cont/Notes/NotesHomePage';
import { getIsSubscribedToGoal } from '@api/selectors/subscription';
import { useSetSelectedNav } from '@stores/sidenav';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getMe, getIsLoggedIn } from '@api/selectors/auth';
import { useEffect, useMemo } from 'react';

const PlusNotesPage = () => {
  const router = useRouter();
  const {
    query: { goalUID: uid }
  } = router;
  const { goalInfo } = useGoalInfo(uid);
  const {
    name = 'Goal',
    thumbnail,
    ogImage,
    slug: goalSlug,
    uid: goalUID
  } = goalInfo ?? {};

  const metaTitle = `Important topics for ${name} - Unacademy`;
  const metaDescription = `Explore various notes topic wise to prepare for ${name}`;
  const canonicalURL = `https://unacademy.com/goal/${goalSlug}/${goalUID}/notes`;
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const meInfo = useMyInfo(getMe);
  const isSubscribed = useMemo(
    () => getIsSubscribedToGoal(goalUID)(meInfo),
    [meInfo, goalUID]
  );
  useSetSelectedNav('notes');
  useEffect(() => {
    if (isLoggedIn && goalInfo && meInfo && !isSubscribed) {
      router.push(`/goal/${goalSlug}/${goalUID}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn, goalUID, goalSlug, isSubscribed]);
  return (
    <>
      <SEO
        title={metaTitle}
        description={metaDescription}
        openGraph={{
          metaTitle,
          metaDescription,
          images: [
            {
              url: ogImage || thumbnail
            }
          ],
          url: canonicalURL
        }}
        schema={subGoalSchema({
          goal: goalInfo,
          description: metaDescription,
          subGoal: { name: 'Syllabus', link: 'topics' }
        })}
      />
      <Head>
        <title>{metaTitle}</title>
      </Head>

      <NotesHomePage goalTopology={goalInfo} />
    </>
  );
};

PlusNotesPage.pageInfo = {
  isMWebSupported: true,
  isProtected: true,
  name: NOTES,
  layoutOptions: {
    showPlusNav: true
  },
  isCMSMeta: true
};
export const getStaticProps = async ({ params: query }) => {
  const { goalUID } = query;
  if (!goalUID)
    return {
      redirect: { destination: '/404' }
    };

  return {
    props: {}
  };
};

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking'
  };
};
PlusNotesPage.Layout = Layout;

export default PlusNotesPage;
PlusNotesPage.Wrapper = PageReduxProvider;
